import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import React, { useRef } from 'react';
import useMaskedInput from '../utils/useMaskedInput';
import BasicInput, { useOptionallyControlledInput } from '../../shared/input';

var MaskedInput = function MaskedInput(_ref) {
  var mask = _ref.mask,
      guide = _ref.guide,
      keepCharPositions = _ref.keepCharPositions,
      pipe = _ref.pipe,
      placeholderChar = _ref.placeholderChar,
      showMask = _ref.showMask,
      otherInputProps = _objectWithoutProperties(_ref, ["mask", "guide", "keepCharPositions", "pipe", "placeholderChar", "showMask"]);

  var _useOptionallyControl = useOptionallyControlledInput(otherInputProps),
      value = _useOptionallyControl.value,
      onChange = _useOptionallyControl.onChange;

  var inputRef = useRef(null);
  var onChangeMasked = useMaskedInput({
    inputRef: inputRef,
    mask: mask,
    onChange: onChange,
    value: value,
    guide: guide,
    keepCharPositions: keepCharPositions,
    pipe: pipe,
    placeholderChar: placeholderChar,
    showMask: showMask
  });
  return /*#__PURE__*/React.createElement(BasicInput, _extends({}, otherInputProps, {
    inputRef: inputRef,
    onChange: onChangeMasked,
    value: value
  }));
};

export default MaskedInput;